import { defineMessages } from 'react-intl';

const messages = defineMessages({
  title: {
    id: 'Fullwidth image',
    defaultMessage: 'Imatge amplada completa',
  },
  image: {
    id: 'Fullwidth image file',
    defaultMessage: 'Imatge',
  },
  alt: {
    id: 'Fullwidth image alt',
    defaultMessage: 'Text alternatiu',
  },
});

export const FullwidthImageSchema = ({ intl }) => ({
  title: intl.formatMessage(messages.title),
  fieldsets: [{ id: 'default', title: 'Default', fields: ['image', 'alt'] }],
  properties: {
    image: {
      title: intl.formatMessage(messages.image),
      widget: 'object_browser',
      mode: 'image',
      return: 'single',
      selectableTypes: ['Image'],
      initialPath: '/recursos',
      selectedItemAttrs: ['@type', 'title', 'image_field', 'image_scales'],
    },
    alt: {
      title: intl.formatMessage(messages.alt),
      widget: 'text',
    },
  },
  required: ['image'],
});
